import { all, call, put, select, takeEvery } from "redux-saga/effects";
import {
  deleteTagOfSourceAPI,
  getTagsByProjectId,
  getTagsBySourceId,
  deleteTagOfProjectAPI,
  addTagToSourceAPI,
  searchProjectTagByTextAPI,
  createProjectTagAPI,
} from "./api";
import {
  ADD_TAG_TO_SOURCE,
  CREATE_PROJECT_TAG,
  CREATE_PROJECT_TAG_AND_ADD_TO_SOURCE,
  DELETE_TAG_OF_PROJECT,
  DELETE_TAG_OF_SOURCE,
  GET_TAGS_BY_PROJECT_ID,
  GET_TAGS_DATA_FOR_TAG_FORM,
  SEARCH_PROJECT_TAG_BY_TEXT,
  showNoti,
} from "redux/actions";
import {
  ERROR_CASE,
  SUCCESS_CASE,
} from "components/notificationModal/constants";
import get from "lodash/get";
import {
  getTagDataForTagFormSuccess,
  getTagsByProjectIdError,
  getTagsByProjectIdSuccess,
  updateCurrentTags,
  deleteCurrentTags,
} from "./actions";
import { selectSourceTags } from "./selectors";
import { updateItemsByTags } from "redux/datasetDetail_v2/action";

function* getTagsDataForTagFormSaga({ payload, callback }) {
  const { sourceIds, projectId } = payload;
  const [srcTagsRes, projectTagsRes] = yield all([
    call(getTagsBySourceId, { sourceIds }),
    call(getTagsByProjectId, { projectId }),
  ]);

  const checkSuccessSourceTag =
    srcTagsRes?.status === 200 && srcTagsRes?.data?.status;
  const checkSuccessProjectTag =
    projectTagsRes?.status === 200 && projectTagsRes?.data?.status;

  if (checkSuccessSourceTag && checkSuccessProjectTag) {
    yield put(
      getTagDataForTagFormSuccess({
        srcTags: srcTagsRes.data?.data?.tags,
        projectTags: projectTagsRes.data?.data?.tags,
      }),
    );
  } else {
    yield put(
      showNoti({
        type: ERROR_CASE,
        messageId: "tags.error-to-fetch-tag",
      }),
    );
  }

  callback &&
    callback({ srcTags: srcTagsRes.data, projectTags: projectTagsRes.data });
}

function* deleteTagOfSourceSaga({ payload }) {
  const { projectId, sourceIds, tags } = payload;
  const response = yield call(deleteTagOfSourceAPI, {
    projectId,
    sourceIds,
    tags,
  });
  const checkResponse = response?.status === 200 && response?.data?.status;
  const allTags = yield select(selectSourceTags);
  const updatedSourceTags = allTags.filter(
    (item) => !tags.includes(item.tag_id),
  );
  yield put(deleteCurrentTags(updatedSourceTags));
  yield put(updateItemsByTags({ tags: updatedSourceTags ?? [], sourceIds }));
  yield put(
    showNoti({
      type: checkResponse ? SUCCESS_CASE : ERROR_CASE,
      messageId: checkResponse
        ? "tags.delete-tag-of-source-success"
        : "tags.delete-tag-of-source-error",
    }),
  );
}

function* deleteTagOfProjectSaga({ payload }) {
  const { projectId, tags } = payload;
  const response = yield call(deleteTagOfProjectAPI, {
    projectId,
    tags,
  });
  const checkResponse = response?.status === 200 && response?.data?.status;

  yield put(
    showNoti({
      type: checkResponse ? SUCCESS_CASE : ERROR_CASE,
      messageId: checkResponse
        ? "tags.delete-tag-of-project-success"
        : "tags.delete-tag-of-project-error",
    }),
  );
}

function* searchProjectTagByTextSaga({ payload, callback }) {
  const { projectId, textSearch } = payload;
  const response = yield call(searchProjectTagByTextAPI, {
    projectId,
    textSearch,
  });
  const checkResponse = response?.status === 200 && response?.data?.status;

  if (!checkResponse) {
    yield put(
      showNoti({
        type: ERROR_CASE,
        messageId: "tags.search-project-tag-by-text-error",
      }),
    );
  }
  callback && callback(response?.data?.data);
}

function* createProjectTagSaga({ payload }) {
  const { projectId, newtag } = payload;
  const response = yield call(createProjectTagAPI, {
    projectId,
    newtag,
  });
  const checkResponse = response?.status === 200 && response?.data?.status;

  yield put(
    showNoti({
      type: checkResponse ? SUCCESS_CASE : ERROR_CASE,
      messageId: checkResponse
        ? "tags.add-tag-to-project-successfully"
        : "tags.add-tag-to-project-error",
    }),
  );
  return response?.data?.data;
}

function* createProjectTagAndAddToSourceSaga({ payload }) {
  const res = yield call(createProjectTagSaga, { payload });

  if (res)
    yield call(addTagToSourceSaga, {
      payload: {
        ...payload,
        tags: res.tags,
      },
    });
}

function* addTagToSourceSaga({ payload }) {
  const { projectId, tags, sourceIds } = payload;
  const response = yield call(addTagToSourceAPI, {
    projectId,
    sourceIds,
    tags: tags.map((item) => item.tag_id),
  });
  const allTags = yield select(selectSourceTags);
  yield put(updateCurrentTags([...allTags, ...tags]));
  yield put(
    updateItemsByTags({ tags: [...allTags, ...tags] ?? [], sourceIds }),
  );
  const checkResponse = response?.status === 200 && response?.data?.status;

  yield put(
    showNoti({
      type: checkResponse ? SUCCESS_CASE : ERROR_CASE,
      messageId: checkResponse
        ? "tags.add-tag-to-source-successfully"
        : "tags.add-tag-to-source-error",
    }),
  );
}

function* watchGetTagsByProjectIdSaga({ payload }) {
  const { projectId } = payload;
  try {
    const response = yield call(getTagsByProjectId, { projectId });
    const statusCode = get(response, "status", "");
    if (statusCode === 200) {
      const { tags } = get(response, "data.data", []);
      yield put(getTagsByProjectIdSuccess({ tags }));
    }
  } catch (error) {
    yield put(getTagsByProjectIdError);
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(GET_TAGS_DATA_FOR_TAG_FORM, getTagsDataForTagFormSaga),
    takeEvery(DELETE_TAG_OF_SOURCE, deleteTagOfSourceSaga),
    takeEvery(DELETE_TAG_OF_PROJECT, deleteTagOfProjectSaga),
    takeEvery(ADD_TAG_TO_SOURCE, addTagToSourceSaga),
    takeEvery(SEARCH_PROJECT_TAG_BY_TEXT, searchProjectTagByTextSaga),
    takeEvery(CREATE_PROJECT_TAG, createProjectTagSaga),
    takeEvery(
      CREATE_PROJECT_TAG_AND_ADD_TO_SOURCE,
      createProjectTagAndAddToSourceSaga,
    ),
    takeEvery(GET_TAGS_BY_PROJECT_ID, watchGetTagsByProjectIdSaga),
  ]);
}
